import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRentalOverview,
} from '../../Redux/Actions/actions';
import RentalDashboard from '../../Components/RentalDashboard/RentalDashboard';
import style from './RentalManagement.module.css';

const RentalManagement = () => {
  const dispatch = useDispatch();
  const {
    rentalOverview,
    rentalsLoading,
    rentalsError,
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(fetchRentalOverview({ type: 'all' }));
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(fetchRentalOverview({ type: 'all' }));
  };

  const isLoading = rentalsLoading && !rentalOverview;

  if (isLoading) {
    return (
      <div className={style.container}>
        <div className={style.loading}>Cargando dashboard de alquileres...</div>
      </div>
    );
  }

  if (rentalsError) {
    return (
      <div className={style.container}>
        <div className={style.error}>
          Error al cargar el dashboard: {rentalsError}
        </div>
      </div>
    );
  }

  const productionData = rentalOverview?.produccion || null;
  const administrationData = rentalOverview?.administracion || null;

  return (
    <div className={style.container}>
      <h1 className={style.title}>Gestión de Alquileres</h1>

      <RentalDashboard
        data={productionData}
        adminData={administrationData}
        overview={rentalOverview}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default RentalManagement;